import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
export var fontFamily = getFontFamily();